var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2442 7.37485C2.86078 7.87664 1.07153 9.99142 1.07153 12.5241C1.07153 15.4303 3.42749 17.7863 6.3337 17.7863C6.37297 17.7863 6.41217 17.7858 6.45127 17.785C6.46972 17.7859 6.48822 17.7864 6.50677 17.7864H15.6557L13.7985 15.9291H6.57018L6.5407 15.9241L6.44731 15.9272C6.40963 15.9284 6.37176 15.929 6.3337 15.929C4.4532 15.929 2.92876 14.4046 2.92876 12.5241C2.92876 10.6436 4.4532 9.11916 6.3337 9.11916C6.35417 9.11916 6.37458 9.11934 6.39493 9.11969L6.99965 9.1303L5.2442 7.37485ZM18.948 15.8256C20.2105 15.4828 21.139 14.3286 21.139 12.9576C21.139 11.3164 19.8086 9.98597 18.1674 9.98597C18.0198 9.98597 17.8752 9.99667 17.7343 10.0172L16.6674 10.1726L16.6719 9.09439L16.6721 9.0574L16.672 9.05547C16.6709 6.76571 14.6362 4.78576 11.967 4.78576C10.7915 4.78576 9.73542 5.17257 8.92326 5.80088L7.6022 4.47983C8.77089 3.50911 10.3076 2.92853 11.967 2.92853C15.1973 2.92853 17.9782 5.1401 18.4567 8.13727C20.9889 8.28687 22.9962 10.3878 22.9962 12.9576C22.9962 14.8288 21.9319 16.4515 20.3755 17.2531L18.948 15.8256Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.02295,
    y: 3.21423,
    width: 22.2166,
    height: 1.85723,
    rx: 0.928614,
    transform: "rotate(45 5.02295 3.21423)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConnection);
export default __webpack_public_path__ + "static/media/no-connection.a8449f40507004c4c7ab6a6d91a8a8ba.svg";
export { ForwardRef as ReactComponent };